(function () {
  'use strict';

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const T = Object.assign({
    centre_select: 'Select Test Centre',
    centre_none: 'No test centres available',
    centre_error: 'Could not load centres — refresh to retry',
    type_select_default: 'Select Test Type',
    type_hint: 'Choose a centre to see available tests',
    type_loading: 'Loading Test Types...',
    type_none: 'No tests currently available at this centre',
    type_error: 'Could not load test types. Please try again.',
    type_available_count: '{count} test type(s) available',
    book_now: 'Book Now',
    processing: 'Processing...',
    err_select_centre: 'Please select a test centre',
    err_select_type: 'Please select a test type',
    generic_error: 'Something went wrong. Please try again.'
  }, window.byrtI18n || {});

  const centreSelect = document.getElementById('byrt-centre-select');
  const typeSelect = document.getElementById('byrt-type-select');
  const typeStatus = document.getElementById('byrt-type-status');
  const bookBtn = document.getElementById('byrt-book-btn');
  const cancelMessage = document.getElementById('byrt-cancel-message');
  const cancelSearchBtn = document.getElementById('byrt-cancel-search-btn');
  const tabs = document.querySelectorAll('.byrt-tab');
  const typeRow = document.getElementById('byrt-type-row');
  const centreRow = document.getElementById('byrt-centre-row');

  if (!centreSelect) return;

  function fetchAllProducts(page, accumulated) {
    return fetch(`${ROOT}collections/all/products.json?limit=250&page=${page}`)
      .then((r) => {
        if (!r.ok) throw new Error('network');
        return r.json();
      })
      .then((data) => {
        const products = data.products || [];
        const all = accumulated.concat(products);
        if (products.length === 250) {
          return fetchAllProducts(page + 1, all);
        }
        return all;
      });
  }

  function populateCentres() {
    centreSelect.disabled = true;
    fetchAllProducts(1, [])
      .then((products) => {
        centreSelect.innerHTML = '<option value="">' + T.centre_select + '</option>';
        const active = products.filter((p) => p.status === 'active' || p.published_at);
        active.forEach((p) => {
          const opt = document.createElement('option');
          opt.value = p.id;
          opt.dataset.handle = p.handle;
          opt.textContent = p.title;
          centreSelect.appendChild(opt);
        });
        if (!active.length) {
          centreSelect.innerHTML = '<option value="">' + T.centre_none + '</option>';
        }
        centreSelect.disabled = false;
      })
      .catch(() => {
        centreSelect.innerHTML = '<option value="">' + T.centre_error + '</option>';
        centreSelect.disabled = false;
      });
  }

  populateCentres();

  let activeTab = 'book';
  const panelBook = document.getElementById('byrt-panel-book');
  const panelCancel = document.getElementById('byrt-panel-cancel');

  function switchPanel(outPanel, inPanel) {
    outPanel.classList.add('byrt-tab-panel--exit');
    setTimeout(() => {
      outPanel.classList.add('byrt-tab-panel--hidden');
      outPanel.classList.remove('byrt-tab-panel--exit');
      inPanel.classList.remove('byrt-tab-panel--hidden');
      inPanel.classList.add('byrt-tab-panel--enter');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          inPanel.classList.remove('byrt-tab-panel--enter');
        });
      });
    }, 200);
  }

  function setTabActive(tab) {
    if (tab === activeTab) return;
    activeTab = tab;
    tabs.forEach((t) => {
      t.classList.toggle('byrt-tab--active', t.dataset.tab === tab);
      t.setAttribute('aria-selected', t.dataset.tab === tab);
    });
    if (tab === 'cancel') {
      switchPanel(panelBook, panelCancel);
    } else {
      switchPanel(panelCancel, panelBook);
    }
  }

  tabs.forEach((t) => {
    t.addEventListener('click', () => setTabActive(t.dataset.tab));
  });

  function checkCartEmpty() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then((r) => r.json())
      .then((cart) => cart.item_count === 0);
  }

  function clearErrors() {
    [centreSelect, typeSelect].forEach((el) => {
      el.style.borderColor = '';
      const next = el.parentElement.nextElementSibling;
      if (next && next.classList.contains('byrt-field-error')) next.remove();
    });
  }

  function showFieldError(el, msg) {
    el.style.borderColor = '#E53E3E';
    let next = el.parentElement.nextElementSibling;
    let err = next && next.classList.contains('byrt-field-error') ? next : null;
    if (!err) {
      err = document.createElement('p');
      err.className = 'byrt-field-error';
      err.style.cssText = 'color:#E53E3E;font-size:12px;margin:4px 0 0';
      el.parentElement.insertAdjacentElement('afterend', err);
    }
    err.textContent = msg;
  }

  centreSelect.addEventListener('change', function () {
    const handle = this.options[this.selectedIndex]?.dataset?.handle;
    typeSelect.innerHTML = '<option value="">' + T.type_select_default + '</option>';
    typeSelect.disabled = true;
    typeStatus.textContent = '';

    if (!handle) {
      typeStatus.textContent = T.type_hint;
      return;
    }

    typeStatus.textContent = T.type_loading;

    fetch(`${ROOT}products/${handle}.js`)
      .then((r) => {
        if (!r.ok) throw new Error('network');
        return r.json();
      })
      .then((product) => {
        const available = product.variants.filter((v) => v.available);
        const hasRealVariants = available.some((v) => v.title !== 'Default Title');

        if (!hasRealVariants) {
          typeRow.style.display = 'none';
          typeStatus.textContent = '';
          centreSelect.dataset.directBook = handle;
          return;
        }

        typeRow.style.display = '';
        centreSelect.dataset.directBook = '';

        if (!available.length) {
          typeStatus.textContent = T.type_none;
          return;
        }
        available.forEach((v) => {
          const opt = document.createElement('option');
          opt.value = v.id;
          opt.textContent = v.title;
          typeSelect.appendChild(opt);
        });
        typeSelect.disabled = false;
        typeStatus.textContent = T.type_available_count.replace('{count}', available.length);
      })
      .catch(() => {
        typeStatus.style.color = '#E53E3E';
        typeStatus.textContent = T.type_error;
      });
  });

  bookBtn.addEventListener('click', function (e) {
    e.preventDefault();
    clearErrors();

    if (activeTab === 'cancel') {
      const handle = centreSelect.options[centreSelect.selectedIndex]?.dataset?.handle;
      if (!handle) {
        showFieldError(centreSelect, T.err_select_centre);
        centreSelect.focus();
        return;
      }
      window.location.href = `/pages/cancellation-finder?centre=${handle}`;
      return;
    }

    if (!centreSelect.value) {
      showFieldError(centreSelect, T.err_select_centre);
      centreSelect.focus();
      return;
    }

    const directBookHandle = centreSelect.dataset.directBook;
    if (directBookHandle) {
      bookBtn.disabled = true;
      bookBtn.innerHTML = '<span class="byrt-spinner"></span> ' + T.processing;

      checkCartEmpty()
        .then((isEmpty) => {
          if (!isEmpty) {
            window.location.href = '/cart?booking_limit=1';
            return;
          }
          return fetch(`/products/${directBookHandle}.js`)
            .then((r) => {
              if (!r.ok) throw new Error('product');
              return r.json();
            })
            .then((product) => {
              const variantId = product.variants[0]?.id;
              if (!variantId) throw new Error('no variant');
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1 }),
              });
            })
            .then((r) => {
              if (!r.ok) throw new Error('cart');
              return r.json();
            })
            .then(() => {
              window.location.href = '/cart';
            });
        })
        .catch(() => {
          bookBtn.disabled = false;
          bookBtn.textContent = T.book_now + ' →';
          alert(T.generic_error);
        });
      return;
    }

    if (!typeSelect.value) {
      showFieldError(typeSelect, T.err_select_type);
      typeSelect.focus();
      return;
    }

    bookBtn.disabled = true;
    bookBtn.innerHTML = '<span class="byrt-spinner"></span> ' + T.processing;

    checkCartEmpty()
      .then((isEmpty) => {
        if (!isEmpty) {
          window.location.href = '/cart?booking_limit=1';
          return;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(typeSelect.value, 10), quantity: 1 }),
        })
          .then((r) => {
            if (!r.ok) throw new Error('cart');
            return r.json();
          })
          .then(() => {
            window.location.href = '/cart';
          });
      })
      .catch(() => {
        bookBtn.disabled = false;
        bookBtn.textContent = T.book_now + ' →';
        alert(T.generic_error);
      });
  });

  if (cancelSearchBtn) {
    cancelSearchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      clearErrors();

      cancelSearchBtn.disabled = true;
      cancelSearchBtn.innerHTML = '<span class="byrt-spinner"></span> ' + T.processing;

      checkCartEmpty()
        .then((isEmpty) => {
          if (!isEmpty) {
            window.location.href = '/cart?booking_limit=1';
            return;
          }
          // Use fixed cancellation search product handle
          return fetch('/products/cancellation-search.js')
            .then((r) => {
              if (!r.ok) throw new Error('product');
              return r.json();
            })
            .then((product) => {
              const variantId = product.variants[0]?.id;
              if (!variantId) throw new Error('no variant');
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1 }),
              });
            })
            .then((r) => {
              if (!r.ok) throw new Error('cart');
              return r.json();
            })
            .then(() => {
              window.location.href = '/cart';
            });
        })
        .catch(() => {
          cancelSearchBtn.disabled = false;
          cancelSearchBtn.textContent = T.book_now + ' →';
          alert(T.generic_error);
        });
    });
  }

  typeStatus.textContent = T.type_hint;

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      bookBtn.disabled = false;
      bookBtn.textContent = T.book_now;
      if (cancelSearchBtn) {
        cancelSearchBtn.disabled = false;
        cancelSearchBtn.textContent = T.book_now;
      }
    }
  });
})();
